var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon Expand",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1",
    d: "M10.75.75v20"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    d: "M20.75 10.75h-20"
  }))));
}
export default SvgExpand;